import { useTheme, Typography, Button, useMediaQuery } from '@mui/material';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Trans, useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { analytics, events } from 'services/analytics';
import { InfoBannerContainer } from './styled';

type PropTypes = {
  url: string;
};

const InfoBanner = ({ url }: PropTypes) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const handleTrackClick = () => {
    analytics.track(events.generateButtonClickDetails());
  };

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <InfoBannerContainer>
      <Typography>
        <Trans
          i18nKey={t('songDetail:infoBanner:infoText')}
          components={{
            1: <strong style={{ color: theme.palette.primary.main }} />,
          }}
        />
      </Typography>
      <Button
        component={RouterLink}
        href={url}
        to={{
          pathname: url,
        }}
        variant="text"
        disableRipple={isMobile}
        onClick={handleTrackClick}
        sx={{
          fontSize: 16,
          [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(0),
          },
        }}
      >
        {t('songDetail:infoBanner:buttonText')}
        <KeyboardArrowRight />
      </Button>
    </InfoBannerContainer>
  );
};
export default InfoBanner;
